import { render, staticRenderFns } from "./NavSidebar.vue?vue&type=template&id=731acb9a&"
import script from "./NavSidebar.vue?vue&type=script&lang=ts&"
export * from "./NavSidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports